export default __webpack_public_path__ + "static/media/dimo_development.png";